<template lang="pug">
div
  .optional.mb-4(v-if='leaseOptions.length > 0')
    h3 Optioneel
    v-divider.mt-3.white
    v-checkbox(
      v-for='lopt in leaseOptions'
      :key='lopt._id',
      color='primary',
      hide-details,
      v-model='lopt.userEnabled',
      :label='"Ik wil ook graag een offerte ontvangen voor een " + getLeaseOptionLabel(lopt.name)'
      )
</template>

<script>
import { leaseOptionsAll } from './helpers/constants'

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    return {
      leaseOptions: this.value
    }
  },

  methods: {
    getLeaseOptionLabel (name) {
      return leaseOptionsAll.find(x => x.name === name).label
    }
  },

  watch: {
    value (v) {
      this.leaseOptions = v
    },

    leaseOptions: {
      handler: function (v) {
        v.forEach(x => {
          delete x._id
          delete x.enabled
          delete x.productType
        })

        this.$emit('input', v)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/variables.scss";

.optional {
  background: $accent;
  padding: $g;
}
</style>
